import React from "react";
import { Card, CardBody } from "reactstrap";
import FeatherIcon from "feather-icons-react";

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};


const Timeline = () => {
  const timelineEvents = [
    {
      type: "system",
      icon: "bell",
      user: "System Automation",
      description: "Alert received: High latency detected in Payment API.",
      timestamp: "15:30:00, 10/30/24",
    },
    {
      type: "system",
      icon: "play-circle",
      user: "System Automation",
      description:
        'Playbook "Payment Service Latency Incident Response" triggered.',
      timestamp: "15:30:15, 10/30/24",
    },
    {
      type: "user",
      icon: "user",
      user: "Alex Chen",
      description:
        "Acknowledged incident and began initial triage. Confirmed latency metrics.",
      timestamp: "15:32:05, 10/30/24",
    },
    {
      type: "system",
      icon: "settings",
      user: "System Automation",
      description:
        "Automatic traffic rerouting to healthy instances initiated.",
      timestamp: "15:33:10, 10/30/24",
    },
    {
      type: "alert",
      icon: "alert-triangle",
      user: "Alex Chen",
      description:
        "Severity escalated from Medium to Critical due to widespread customer impact.",
      timestamp: "15:35:45, 10/30/24",
    },
    {
      type: "user",
      icon: "activity",
      user: "Alex Chen",
      description:
        "Incident status updated: Investigating → Fixing. Focusing on database connection pools.",
      timestamp: "15:36:00, 10/30/24",
    },
    {
      type: "user",
      icon: "message-square",
      user: "Sarah Kim",
      description:
        "Joined incident response. Reviewing recent code deployments for potential correlation.",
      timestamp: "15:40:10, 10/30/24",
    },
  ];

  const getIconColor = (type) => {
    if (type === "system") return "#6c757d";
    if (type === "alert") return "#dc3545";
    return "#212529";
  };

  return (
    <Card className="shadow-sm border mt-4" style={cardShell}>
      <CardBody className="p-4">
        <h5 className="fw-bold mb-4">Timeline</h5>

        <div style={{ position: "relative" }}>
          {timelineEvents.map((event, index) => (
            <div key={index} className="d-flex mb-4" style={{ position: "relative" }}>
              {/* Icon */}
              <div
                style={{
                  minWidth: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  backgroundColor: "#f8f9fa",
                  border: "2px solid #e9ecef",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                  zIndex: 1,
                }}
              >
                <FeatherIcon
                  icon={event.icon}
                  size={14}
                  style={{ color: getIconColor(event.type) }}
                />
              </div>

              {/* Connecting line */}
              {index !== timelineEvents.length - 1 && (
                <div
                  style={{
                    position: "absolute",
                    left: "15px",
                    top: "32px",
                    bottom: "-16px",
                    width: "2px",
                    backgroundColor: "#e9ecef",
                  }}
                />
              )}

              {/* Text */}
              <div style={{ flex: 1 }}>
                <div className="d-flex justify-content-between align-items-start mb-1">
                  <p
                    className="mb-0 fw-semibold"
                    style={{ fontSize: "14px", color: "#212529" }}
                  >
                    {event.user}
                  </p>
                  <span
                    className="text-muted"
                    style={{ fontSize: "12px", whiteSpace: "nowrap" }}
                  >
                    {event.timestamp}
                  </span>
                </div>
                <p
                  className="mb-0 text-muted"
                  style={{ fontSize: "14px", lineHeight: "1.5" }}
                >
                  {event.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  );
};

export default Timeline;
